<nz-spin [nzSpinning]="loading">
  <nz-card>
  <div class="表格" >
    <div >
      <strong class="margin-left-8 result">{{ "Results" | translate}}({{nzTotal}})</strong>
    </div>
    <nz-table #colSpanTable [nzData]="listOfData"  nzSize="middle" nzShowSizeChanger
  [nzFrontPagination]="false" [nzShowPagination]='false' [nzPageSize]='pageSize'
      [nzPageIndex]='pageIndex' [nzScroll]="{ y: '600px',x:'1500px' }">
      <thead>
        <tr>
         
          <th scope="col" nzWidth="10%" style="text-align:center;">{{ "mailtype" | translate}}</th>
          <th scope="col" nzWidth="20%" style="text-align:center;">{{ "mailtille" | translate}}_ZH/EN</th>
          <th scope="col" nzWidth="20%" style="text-align:center;">{{ "mailtille" | translate}}_VN</th>
          <th scope="col" nzWidth="60%" style="text-align:center;">{{ "mailtext" | translate}}_ZH/EN</th>
          <th scope="col" nzWidth="60%" style="text-align:center;">{{ "mailtext" | translate}}_VN</th>
          <th scope="col" nzWidth="10%" style="text-align:center;">{{ "excludeSite" | translate}}</th>

          <th scope="col" nzWidth="10%" style="text-align:center;" [nzRight]="true">{{ "mailyesorno" | translate}}</th>
          <th scope="col" nzWidth="10%" style="text-align:center;" [nzRight]="true">{{ "act" | translate}}</th>
        </tr>
      </thead>
      <tbody>
        <tr *ngFor="let data of colSpanTable.data;let i=index">
          <!-- <td><img src="../../../assets/image/img_edit.png" [alt]="'Button.Update'|translate" (click)="ActButton(data)"
              class="pointer"></td> -->
        
          <td style="text-align:center;">{{data.mailType}}</td>
          <td>{{data.subject}}</td>
          <td>{{data.vnSubject}}</td>
          <td>{{data.mailMsg}}</td>
          <td>{{data.vnMailMsg}}</td>
          <td>{{data.exclSite}}</td>

          <td style="text-align:center;" [nzRight]="true">
            <div *ngIf="data.sendButton=='Y' ">
              <nz-switch [ngModel]="true" (click)="onOff(data)"></nz-switch>
            </div>
            <div *ngIf="data.sendButton=='N' ">
              <nz-switch [ngModel]="false" (click)="onopen(data)"></nz-switch>
            </div>
          </td>
          <td [nzRight]="true" style="text-align: center;">
            <span nz-icon nzType="edit" nzTheme="twotone" (click)="ActButton(data)" style="font-size: 20px; cursor: pointer;"></span>
           </td>

        </tr>
      </tbody>
    </nz-table>
    <nz-pagination style="float:right;" [(nzPageIndex)]="pageIndex" [nzTotal]="nzTotal" [nzSize]="'small'" nzShowSizeChanger
 [nzPageSize]='pageSize' (nzPageSizeChange)="nzPageSizeChange($event)"  [nzPageSizeOptions]="[10, 20, 50,100]"
    (nzPageIndexChange)="nzPageIndexChange($event)"></nz-pagination>
    <ng-template #renderItemTemplate let-type let-page="page">
         
      <a *ngIf="type === 'page'">{{ page }}</a>
      <a *ngIf="type === 'prev'" [style.color]="'black'">&#60;</a>
      <a *ngIf="type === 'next'" [style.color]="'black'">&#62;</a>
    </ng-template>
  </div>
</nz-card>
</nz-spin>
<form nz-form [formGroup]="validateForm">
  <nz-modal [(nzVisible)]="isVisible" nzTitle="{{'MailServiceSettings' | translate}}" (nzOnCancel)="Cancel()" (nzOnOk)="OnOk()">
    <ng-container *nzModalContent>

<div style="margin-top: 20px;margin-bottom: -20px;">
  <div nz-row>
    <div nz-col nzSpan="24">
      <nz-form-item>
        <nz-form-label nzSpan="8">
          <div class="width-100-percent label-font"><span style="color: red;"> *</span>{{ "mailtype" | translate}}
          </div>
        </nz-form-label>
        <nz-form-control nzSpan="12">
          <input nz-input formControlName="mailtype" />
        </nz-form-control>
      </nz-form-item>
    </div>
  </div>

  <div nz-row>
    <div nz-col nzSpan="24">
      <nz-form-item>
        <nz-form-label nzSpan="8">
          <div class="width-100-percent label-font"><span style="color: red;"> *</span>{{ "mailtille" | translate}}_ZH/EN
          </div>
        </nz-form-label>
        <nz-form-control nzSpan="12">
          <textarea rows="2" nz-input formControlName="mailtilleZHEN"></textarea>
        </nz-form-control>
      </nz-form-item>
    </div>
  </div>

  <div nz-row>
    <div nz-col nzSpan="24">
      <nz-form-item>
        <nz-form-label nzSpan="8">
          <div class="width-100-percent label-font"><span style="color: red;"> *</span>{{ "mailtext" | translate}}_ZH/EN
          </div>
        </nz-form-label>
        <nz-form-control nzSpan="12">
          <textarea rows="5" nz-input
          formControlName="mailtextZHEN"></textarea>
        </nz-form-control>
      </nz-form-item>
    </div>
  </div>

  <div nz-row>
    <div nz-col nzSpan="24">
      <nz-form-item>
        <nz-form-label nzSpan="8">
          <div class="width-100-percent label-font"><span style="color: red;"> *</span>{{ "mailtille" | translate}}_VN
          </div>
        </nz-form-label>
        <nz-form-control nzSpan="12">
          <textarea rows="5" nz-input
          formControlName="mailtilleVN"></textarea>
        </nz-form-control>
      </nz-form-item>
    </div>
  </div>

  <div nz-row>
    <div nz-col nzSpan="24">
      <nz-form-item>
        <nz-form-label nzSpan="8">
          <div class="width-100-percent label-font"><span style="color: red;"> *</span>{{ "mailtext" | translate}}_VN
          </div>
        </nz-form-label>
        <nz-form-control nzSpan="12">
          <textarea rows="5" nz-input
          formControlName="mailtextVN"></textarea>
        </nz-form-control>
      </nz-form-item>
    </div>
  </div>

  
  <div nz-row>
    <div nz-col nzSpan="24">
      <nz-form-item>
        <nz-form-label nzSpan="8">
          <div class="width-100-percent label-font"><span style="color: red;"> *</span>{{ "excludeSite" | translate}}_VN
          </div>
        </nz-form-label>
        <nz-form-control nzSpan="12">
          <nz-select formControlName="Site" nzAllowClear style="width: 100%;" nzMode="multiple">
            <nz-option *ngFor="let option of SiteList" [nzValue]="option.siteName" [nzLabel]="option.siteName">
            </nz-option>
          </nz-select>
        </nz-form-control>
      </nz-form-item>
    </div>
  </div>
</div>

     

      <!-- <nz-table nzBordered nzTemplateMode nzBordered="false">
        <tbody>
          <tr>
            <td><nz-form-label nzRequired>{{ "mailtype" | translate}}</nz-form-label></td>
            <td><nz-form-control><input nz-input formControlName="mailtype" /></nz-form-control></td>
          </tr>
          <tr>
            <td><nz-form-label nzRequired>{{ "mailtille" | translate}}_ZH/EN</nz-form-label></td>
            <td><nz-form-control>
                <textarea rows="2" nz-input formControlName="mailtilleZHEN"></textarea>
              </nz-form-control></td>
          </tr>
          <tr>
            <td><nz-form-label nzRequired>{{ "mailtext" | translate}}_ZH/EN</nz-form-label></td>
            <td><nz-form-control><textarea rows="5" nz-input
                  formControlName="mailtextZHEN"></textarea></nz-form-control>
            </td>
          </tr>
          <tr>
            <td><nz-form-label nzRequired>{{ "mailtille" | translate}}_VN</nz-form-label></td>
            <td><nz-form-control> <textarea rows="2" nz-input
                  formControlName="mailtilleVN"></textarea></nz-form-control></td>
          </tr>
          <tr>
            <td><nz-form-label nzRequired>{{ "mailtext" | translate}}_VN</nz-form-label></td>
            <td><nz-form-control><textarea rows="5" nz-input formControlName="mailtextVN"></textarea></nz-form-control>
            </td>
          </tr>
          <tr>
            <td><nz-form-label nzRequired>{{ "excludeSite" | translate}}</nz-form-label></td>
            <td><nz-form-control>
              <nz-select formControlName="Site" nzAllowClear style="width: 100%;" nzMode="multiple">
                <nz-option *ngFor="let option of SiteList" [nzValue]="option.siteName" [nzLabel]="option.siteName">
                </nz-option>
              </nz-select>
            </nz-form-control></td>
          </tr>

        </tbody>
      </nz-table> -->

    </ng-container>
  </nz-modal>
</form>